import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><path d="M10.296 6a1.704 1.704 0 113.407 0 1.704 1.704 0 01-3.407 0M12 10.296a1.704 1.704 0 100 3.408 1.704 1.704 0 000-3.408m0 6a1.704 1.704 0 100 3.408 1.704 1.704 0 000-3.408" /></svg>;